import { Component, OnInit, OnDestroy } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Subscription } from "rxjs";

import { ModalService } from "src/app/core/modal.service";
import { StrikeService } from "src/app/core/strike.service";
import { MemberDetails, MemberDetailsPage } from "src/app/shared/interfaces/member-details";

import { EditMemberComponent } from "../modals/edit-member/edit-member.component";

@Component({
  selector: "app-strike-members",
  templateUrl: "./strike-members.component.html",
  styleUrls: ["./strike-members.component.css"],
})
export class StrikeMembersComponent implements OnInit, OnDestroy {
  subscription: Subscription = new Subscription
  loadingMembers = true;
  page = 0;
  pageCount = 0;
  totalCount = 0;
  strikeMembers: MemberDetails[] | null = null;
  houseId: number | null = null;
  filterMembers = "";

  constructor(
    private routeService: ActivatedRoute,
    private strikeService: StrikeService,
    private modal: ModalService,
  ) {}

  ngOnInit() {
    this.houseId = Number(this.routeService.snapshot.paramMap.get("id"));
    this.search(this.page);
  }

  ngOnDestroy(){
    if(this.subscription){
      this.subscription.unsubscribe()
    }
  }

  async search(page: number) {
    this.loadingMembers = true;
    const config = {
      params: {
        page: page,
        pageSize: 20,
        filter: this.filterMembers,
      },
    };
    if (this.houseId) {
      const result: MemberDetailsPage = await this.strikeService.getStrikeMembers(
        this.houseId,
        config
      );
      this.strikeMembers = result.Items;
      this.page = result.Page;
      this.pageCount = result.TotalPages;
      this.totalCount = result.TotalCount;
      this.loadingMembers = false;
    }
  }
  async clearSearch() {
    this.filterMembers = "";
    this.search(0);
  }

  openEditMemberModal(memberId: string | undefined) {
    if(!memberId){
      return
    }
    const state = {
      memberId: memberId,
      paramId: this.houseId,
    };

    this.modal.openModal(EditMemberComponent, state);

    this.subscription = this.modal.submitClicked
      .asObservable()
      .subscribe((clicked: boolean) => {
        if (clicked) {
          this.modal.submitClicked.next(false);
          // reload current page to see any changes
          this.search(this.page)
        }
        this.subscription.unsubscribe()
      });
  }

  getStatusColor(status: string | undefined) {
    if (status == "A" || status == "N"){
      return "green"
    }
    else {
      return "red"
    }
  }
}
